// extracted by mini-css-extract-plugin
module.exports = {"container":"Gallery_container__2KDYK","images-count":"Gallery_images-count__3FgC7","images-count-text":"Gallery_images-count-text__UjQWv"};